var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg3548057652a)" },
      React.createElement("path", { d: "M.002 12.003c.03.494.357.91.832 1.052l8.792 2.658.323 6.06a.6.6 0 0 0 .602.563.595.595 0 0 0 .45-.2l3.109-3.442 4.405 3.05c.196.137.426.21.666.21.553 0 1.033-.391 1.15-.94L23.988 2.38a.6.6 0 0 0-.812-.67L.706 10.851a1.181 1.181 0 0 0-.704 1.15zm11.063 8.268l-.2-3.823 2.251 1.556-2.051 2.267zm8.097.465l-8.019-5.551L22.387 4.308l-3.226 16.428zm1.992-16.908L10.037 14.583l-8.782-2.654 19.899-8.101z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg3548057652a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })
      )
    )
  );
});